/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingDetailOutdoorSpaceResponseDtoKind } from './listingDetailOutdoorSpaceResponseDtoKind';

export interface ListingDetailOutdoorSpaceResponseDto {
  kind: ListingDetailOutdoorSpaceResponseDtoKind;
  /** @nullable */
  areaM2: number | null;
  sortOrder: number;
}
